import { EmailStep } from './EmailStep'
import { CodeStep } from './CodeStep'
import { OfferTelegramStep } from './OfferTelegramStep'
import { NameStep } from './NameStep'
import { useAuthFlow } from '../model/useAuthFlow'
// EU-сервис: без Telegram-слоя. Код TG-входа сохранён закомментированным.
// import { ENV } from '@shared/config/env'
// import { TelegramAuthButton } from '@features/telegram-auth'

interface AuthFlowProps {
  /** URL для редиректа после успешного прохождения флоу */
  redirectTo: string
}

/**
 * Главный компонент флоу веб-авторизации.
 * @param redirectTo - URL для редиректа после успеха
 */
export const AuthFlow = ({ redirectTo }: AuthFlowProps) => {
  const {
    state, submitting, revalidating, shakeSignal,
    handleEmailSubmit, handleResend, handleVerify, handleNameSubmit,
    handleTelegramLinked, handleSkipTelegram, changeEmail
  } = useAuthFlow({ redirectTo })

  // Пока перепроверяем персистнутый шаг (code/name) через getProfile —
  // не рендерим шаги, иначе мелькнёт NameStep до возможного редиректа.
  if (revalidating) return null

  return (
    <>

      {state.step === 'email' && (
        <>
          <EmailStep
            initialEmail={state.email}
            onSubmit={handleEmailSubmit}
            isSubmitting={submitting}
            errorText={state.error}
            needsRegistration={state.needsRegistration}
          />
          {/* EU-сервис: вход через Telegram отключён (код сохранён).
          {ENV.IS_WEB && <TelegramAuthButton redirectTo={redirectTo} />} */}
        </>
      )}

      {state.step === 'code' && (
        <CodeStep
          email={state.email}
          onSubmit={handleVerify}
          onResend={handleResend}
          onChangeEmail={changeEmail}
          errorText={state.error}
          attemptsLeft={state.attemptsLeft}
          isLocked={state.isLocked}
          nextResendAt={state.nextResendAt}
          isSubmitting={submitting}
          shakeSignal={shakeSignal}
        />
      )}

      {state.step === 'offer-telegram' && (
        <OfferTelegramStep
          onLinked={handleTelegramLinked}
          onSkip={handleSkipTelegram}
        />
      )}

      {state.step === 'name' && (
        <NameStep
          onSubmit={handleNameSubmit}
          isSubmitting={submitting}
          errorText={state.error}
        />
      )}
    </>
  )
}
